import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/UpSquareOutlined";
import AntdIcon from "../components/AntdIcon";
var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpSquareOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpSquareOutlined.displayName = 'UpSquareOutlined';
}
export default /*#__PURE__*/React.forwardRef(UpSquareOutlined);